export default __webpack_public_path__ + "static/media/023-placeholder.cde012d6.png";